import { ACT_CODE } from '$utils/common'
import request from './request'

// 请求接口二次封装
export const request2 = (url: string, reqbody = {}, reqConfig = {}) => {
  return request(url, {
    actCode: ACT_CODE,
    ...reqbody
  }, {
    ...reqConfig
  })
}

/** 查询活动跑马灯数据 */
export const marquee = (params?: object) => {
  return request('/finance-common-operation-ws/api/act/marquee/v1/data', params, { loading: false })
}

/** 查询活动信息 */
export const getActConfigByCode = (actCode: string) => {
  return request('/finance-common-operation-ws/api/act/activity/v1/getActivityInfo', { actCode })
}

/** 获取wxJsSdk */
export const getWxJsSdk = (params?: object) => {
  return request(
    '/finance-common-operation-ws/api/act/wechat/v1/getWxJsSdk',
    params,
    { loading: false, showError: false/* , jweixin: true */ }
  )
}

/** 查询活动信息 */
export const actConf = () => {
  return request2('/finance-common-operation-ws/api/act/activity/v1/actConf')
}

/**
 * 落地页--规则组资格校验
 */
export const ruleCheck = (params?: object) => {
  return request2('/finance-common-operation-ws/api/act/activity/v1/ruleCheck', params, {
    loading: true,
    showError: false
  })
}